import { httpsCallable } from "firebase/functions";
import { getFirebaseServices } from "@core/config/firebase";

export async function invokeVendorCallable(name, payload = {}) {
  const services = getFirebaseServices();
  if (!services?.functions) throw new Error("Firebase Functions are not configured.");
  const result = await httpsCallable(services.functions, name)(payload);
  return result.data ?? {};
}

export function requireOrganizationId(value) {
  const id = String(value ?? "").trim();
  if (!id) throw new Error("Select a vendor organization first.");
  return id;
}
